import { BRAND_NAME } from './meta.js';
import { fetchExtraProductInfo } from './fetch-extra-product-info.js';

/**
 * @typedef {Object} ItemData
 * @property {string} id
 * @property {string} name
 * @property {string} price
 */

/**
 * 
 * @param {ItemData} itemData
 * @returns  {Promise<Object>}
 */
export function createDetailPage(itemData) {
  return fetchExtraProductInfo([itemData.id])
    .then((extraInfo) => {
      const extraProductInfo = extraInfo[0] || {};

      return {
        'ecommerce': {
          'detail': {
            'id': itemData.id,
            'name': itemData.name,
            'price': itemData.price,
            'brand': BRAND_NAME,
            'category': extraProductInfo.elementSectionPath,
            'categoryName': extraProductInfo.elementSectionName,
            'categoryId': extraProductInfo.elementSectionId,
            'bitrixId': itemData.bitrixID,
          },
        },
        'event': 'gtm-ee-event',
        'gtm-ee-event-category': 'Enhanced Ecommerce',
        'gtm-ee-event-action': 'Detail',
        'gtm-ee-event-non-interaction': 'False',
      };
    });
}
